  import { Component, OnInit, Inject, ViewChild, AfterViewInit } from "@angular/core";
  import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  ValidatorFn,
  AbstractControl,
    ValidationErrors
} from "@angular/forms";
  import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from "@angular/material/dialog";
  import Swal from 'sweetalert2';
  import { MatrizConstatacoesService } from "../../../../../services/matriz-constatacao.service";
  import {
    IArquivoManifestacaoModel,
    IManifestacaoAuditadoModel,
    ISalvarManifestacaoDto, StatusManifestacao
  } from "../../../../../models/constatacao.model";
  import { AngularEditorConfig } from "@kolkov/angular-editor";
  import { angularEditorConfig } from "../../../../../shared/util/angularEditorConfig";
  import { ModalCancelarComponent } from "../../../../../shared/components/modal-cancelar/modal-cancelar-component";
  import { IArquivoItemModel } from "../../../../../models/item-solicitacao-tecnica.model";
  import { MatTableDataSource } from "@angular/material/table";
  import { MatPaginator } from "@angular/material/paginator";
  import { MatSort } from "@angular/material/sort";
  import { AuthService } from "../../../../../services/auth.service";
  import { ModalAvaliarManifestacaoComponent } from "../modal-avaliar-manifestacao/modal-avaliar-manifestacao.component";


  @Component({
    selector: 'app-modal-editar-manifestacao',
    templateUrl: './modal-editar-manifestacao.component.html',
    styleUrls: ['./modal-editar-manifestacao.component.scss']
  })
  export class ModalEditarManifestacaoComponent implements OnInit , AfterViewInit {



    config: AngularEditorConfig = {
      editable: true,
      spellcheck: true,
      height: "10rem",
      minHeight: "5rem",
      translate: "yes",
      enableToolbar: true,
      showToolbar: true,
      defaultParagraphSeparator: "",
      defaultFontName: "",
      defaultFontSize: "",
      fonts: [
        { class: "arial", name: "Arial" },
        { class: "times-new-roman", name: "Times New Roman" },
        { class: "calibri", name: "Calibri" },
        { class: "comic-sans-ms", name: "Comic Sans MS" },
      ],
      customClasses: [
        {
          name: "quote",
          class: "quote",
        },
        {
          name: "redText",
          class: "redText",
        },
        {
          name: "titleText",
          class: "titleText",
          tag: "h1",
        },
      ],
      uploadUrl: "v1/image",
      uploadWithCredentials: false,
      sanitize: true,
      toolbarPosition: "top",
      toolbarHiddenButtons: [["bold", "italic"], ["fontSize"]],
    };


    public readonly EDITOR_MAX_CHARS = 500;

    public form: FormGroup;
    public loading = false;
    public submitted: boolean;
    public manifestacao: IManifestacaoAuditadoModel;
    public anexosEnviados: IArquivoItemModel[] = [];
    public anexosRecebidos: IArquivoItemModel[] = [];

    public dataSourceEnviados = new MatTableDataSource<IArquivoItemModel>([]);
    public dataSourceRecebidos = new MatTableDataSource<IArquivoItemModel>([]);

    private foiAvaliado = false;
    private ultimoValorValido: { [key: string]: string } = {};

    // se você usa paginator/sort, declare também:
    @ViewChild('paginatorEnviados') paginatorEnviados!: MatPaginator;
    @ViewChild('sortEnviados') sortEnviados!: MatSort;

    @ViewChild('paginatorRecebidos') paginatorRecebidos!: MatPaginator;
    @ViewChild('sortRecebidos') sortRecebidos!: MatSort;
    private MAX_FILE_SIZE = 28 * 1024 * 1024; // 28MB
    private ALLOWED_TYPES = ['image/png', 'image/jpeg', 'application/pdf',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'video/mp4'];

    constructor(
      private fb: FormBuilder,
      public matDialog: MatDialog,
      private dialogRef: MatDialogRef<ModalEditarManifestacaoComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private authService: AuthService,
      private matrizService: MatrizConstatacoesService
    ) {}

    ngOnInit(): void {
      this.inicializarForm();

      if (this.data?.id) {
        this.carregarManifestacao();
      }

      this.form.get('descricaoEnvio')?.valueChanges.subscribe(valor => {
        this.bloquearSeExcedeuLimite(valor, 'descricaoEnvio');
      });

      this.form.get('descricaoManifestacao')?.valueChanges.subscribe(valor => {
        this.bloquearSeExcedeuLimite(valor, 'descricaoManifestacao');
      });
    }

    ngAfterViewInit(): void {
      this.dataSourceEnviados.paginator = this.paginatorEnviados;
      this.dataSourceEnviados.sort = this.sortEnviados;

      this.dataSourceRecebidos.paginator = this.paginatorRecebidos;
      this.dataSourceRecebidos.sort = this.sortRecebidos;
    }
    private carregarManifestacao(): void {
      this.loading = true;

      this.matrizService.obterManifestacaoAuditado(this.data.osaMatrizExecucaoId)
        .then(res => {
          if (res?.sucesso && res?.dados) {
            this.preencherTelaComManifestacao(res.dados);
          }
        })
        .finally(() => this.loading = false);
    }

    private bloquearSeExcedeuLimite(valor: string, campo: string): void {
      if (!valor) return;

      const qtd = this.contarCaracteres(valor);

      if (qtd > this.EDITOR_MAX_CHARS) {
        // Restaura o HTML anterior — formatação preservada
        const valorAnterior = this.ultimoValorValido[campo] || '';
        this.form.get(campo)?.setValue(valorAnterior, { emitEvent: false });
        this.exibirAviso(`Limite de ${this.EDITOR_MAX_CHARS} caracteres atingido`);
      } else {
        // Guarda o HTML completo como último válido
        this.ultimoValorValido[campo] = valor;
      }
    }

    public getStatusManifestacaoDescricao(status: number | undefined): string {
      if (!status) return 'Desconhecido';

      switch (status) {
        case 1:
          return 'Não iniciada';

        case 2:
          return 'Em Elaboração';

        case 3:
          return 'Enviado';

        case 4:
          return 'Com sugestões acatadas';

        case 5:
          return 'Com sugestões não acatadas';

        case 6:
          return 'Sem sugestões';

        default:
          return 'Desconhecido';
      }
    }

    maxLengthHtml(max: number): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null;
        const length = this.contarCaracteres(control.value);
        return length > max
          ? { maxlength: { requiredLength: max, actualLength: length } }
          : null;
      };
    }

    private inicializarForm(): void {
      this.form = this.fb.group({
        numeroOsa: [{ value: this.data?.numeroOsa || '', disabled: true }],
        prazoResposta: [null, Validators.required], // string DD/MM/YYYY
        nomeResponsavel: ['', [Validators.required, Validators.maxLength(50)]],
        cargoResponsavel: ['', [Validators.required, Validators.maxLength(50)]],
        descricaoEnvio: ['', [Validators.required]],
        descricaoManifestacao: ['', []],
        status: [{ value: '', disabled: true }]
      });

      if (this.data?.visualizar) {
        this.form.disable({ emitEvent: false });
      } else {
        this.form.get('numeroOsa')?.disable({ emitEvent: false });
        this.form.get('status')?.disable({ emitEvent: false });
      }


      this.dataSourceEnviados.data = [];
      this.dataSourceRecebidos.data = [];

    }

    contarCaracteres(valor: string): number {
      if (!valor) return 0;
      return valor
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#\d+;/g, '')
        .replace(/\r?\n|\r/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .length;
    }

    private atualizarConfigEditor(): void {
      this.config = {
        ...this.config,
        editable: true
      };
    }


    public onEditorChange(valor: string, campo: string): void {
      const qtd = this.contarCaracteres(valor);

      if (qtd >= 500) {
        // Pega o texto puro sem as tags e trunca em 500 chars
        const textoLimpo = valor
          .replace(/<[^>]*>/g, '')
          .replace(/&nbsp;/g, ' ')
          .trim();

        if (textoLimpo.length > 500) {
          // Restaura o valor anterior que estava dentro do limite
          const valorTruncado = this.ultimoValorValido[campo] || '';
          this.form.get(campo)?.setValue(valorTruncado, { emitEvent: false });
          this.exibirAviso('Limite de 500 caracteres atingido');
        } else {
          this.ultimoValorValido[campo] = valor;
        }
      } else {
        this.ultimoValorValido[campo] = valor;
      }
    }

    private aplicarRegrasObrigatoriedadePorStatus(): void {
      const status = this.form.get('status')?.value;
      const ctrlDescricao = this.form.get('descricaoManifestacao');

      if (status === StatusManifestacao.Enviado) {
        ctrlDescricao?.setValidators([Validators.required, this.maxLengthHtml(500)]);
      } else {
        ctrlDescricao?.setValidators([this.maxLengthHtml(500)]);
      }

      ctrlDescricao?.updateValueAndValidity({ emitEvent: false });
    }

    private preencherTelaComManifestacao(m: IManifestacaoAuditadoModel): void {
      if (!m) return;

      const prazo = this.toDate(m.prazoResposta);
      const envio = this.toDate(m.dataEnvio);
      const avaliacao = this.toDate(m.dataAvaliacao);

      this.manifestacao = {
        ...m,
        prazoResposta: prazo,
        dataEnvio: envio,
        dataAvaliacao: avaliacao
      };

      this.form.patchValue({
        prazoResposta: prazo,
        nomeResponsavel: m.nomeResponsavel || '',
        cargoResponsavel: m.cargoResponsavel || '',
        descricaoEnvio: m.descricaoEnvio || '',
        descricaoManifestacao: m.descricaoManifestacao || '',
        status: m.status     }, { emitEvent: false });


      this.dataSourceEnviados.data = (m.anexosEnviados || []).map(a => ({
        id: a.id || 0,
        nomeArquivo: a.nomeArquivo,
        arquivo: a.arquivo // base64
      }));

      this.dataSourceRecebidos.data = (m.anexosRecebidos || []).map(a => ({
        id: a.id || 0,
        nomeArquivo: a.nomeArquivo,
        arquivo: a.arquivo
      }));

      this.aplicarRegrasObrigatoriedadePorStatus();
    }

    private getStatusDescricao(status: number): string {
      switch (status) {
        case 1: return 'Não iniciada';
        case 2: return 'Em elaboração';
        case 3: return 'Enviado';
        case 4: return 'Com sugestões acatadas';
        case 5: return 'Com sugestões não acatadas';
        case 6: return 'Sem sugestões';
        default: return '—';
      }
    }

    private toDate(value: any): Date | null {
      if (!value) return null;
      if (value instanceof Date) return value;

      // se vier "dd/MM/yyyy"
      if (typeof value === 'string' && value.includes('/')) {
        const [dd, mm, yyyy] = value.split('/');
        const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        return isNaN(d.getTime()) ? null : d;
      }

      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    }

    private toBRDateString(value: any): string | null {
      const d = this.toDate(value);
      if (!d) return null;
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    }


    public formatarTamanho(bytes: number): string {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    }

    public async salvar(): Promise<void> {
      this.submitted = true;

      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.exibirAviso('Preencha todos os campos obrigatórios');
        return;
      }

      if (!this.dataSourceEnviados?.data || this.dataSourceEnviados.data.length === 0) {
        this.exibirAviso('É necessário anexar pelo menos um arquivo enviado');
        return;
      }
      const formValue = this.form.getRawValue();
      const statusAtual = this.form.get('status')?.value;

      if (statusAtual === StatusManifestacao.Enviado) {

        if (!this.dataSourceRecebidos?.data || this.dataSourceRecebidos.data.length === 0) {
          this.exibirAviso('É necessário anexar pelo menos um arquivo recebido');
          return;
        }

        if (!formValue.descricaoManifestacao || formValue.descricaoManifestacao.trim() === '') {
          this.exibirAviso('A descrição da manifestação recebida é obrigatória');
          return;
        }
      }

      this.loading = true;

      try {
        const formValue = this.form.getRawValue();
        const prazoDate = this.toDate(formValue.prazoResposta);

        const dto = {
          id: this.data?.id || 0,
          osaExecucaoMatrizConstatacaoId: this.data.osaMatrizExecucaoId,
          prazoResposta: prazoDate ? prazoDate.toISOString() : null,
          nomeResponsavel: formValue.nomeResponsavel,
          cargoResponsavel: formValue.cargoResponsavel,
          descricaoEnvio: formValue.descricaoEnvio,
          descricaoManifestacao: formValue.descricaoManifestacao,
          nome: this.manifestacao?.nome || "Manifestação do Auditado",
          responsavelPreenchimento: this.authService.usuario.id,
          status: this.manifestacao?.status || 1,
          dataFinalizacao: this.manifestacao?.dataFinalizacao || null,
          anexosEnviados: this.dataSourceEnviados.data,
          anexosRecebidos: this.dataSourceRecebidos.data
        };

        const res = await this.matrizService.salvarManifestacaoAuditado(dto);

        if (res?.sucesso) {
          this.manifestacao = res.dados;
          this.form.markAsPristine();
          this.submitted = false;
          this.exibirSucesso('Registro salvo com sucesso');
          this.carregarManifestacao();

          if (this.data?.onSaved) {
            this.data.onSaved();
          }
        } else {
          this.exibirErro('Não foi possível salvar');
        }
      } catch {
        this.exibirErro('Não foi possível salvar');
      } finally {
        this.loading = false;
      }
    }

    public podeAvaliar(): boolean {
      if (this.data?.visualizar) return false;

      const status = this.form.get('status')?.value;
      return status === StatusManifestacao.Enviado;
    }

    public podeExibirBotaoEnviar(): boolean {
      if (this.data?.visualizar) return false;

      const status = this.form.get('status')?.value;
      return status !== StatusManifestacao.Enviado;
    }

    public enviar(): void {
      this.submitted = true;

      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.exibirAviso('Preencha todos os campos obrigatórios');
        return;
      }

      if (!this.dataSourceEnviados?.data || this.dataSourceEnviados.data.length === 0) {
        this.exibirAviso('É necessário anexar pelo menos um arquivo enviado');
        return;
      }

      Swal.fire({
        title: 'Enviar Manifestação',
        text: 'Deseja realmente enviar a manifestação ao auditado?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim, enviar',
        cancelButtonText: 'Cancelar'
      }).then(async result => {
        if (result.value) {
          await this.salvarAntesDEnviar();
        }
      });
    }

    private async salvarAntesDEnviar(): Promise<void> {
      this.submitted = true;

      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.exibirAviso('Preencha todos os campos obrigatórios');
        return;
      }

      this.loading = true;

      try {
        const formValue = this.form.getRawValue();
        const prazoDate = this.toDate(formValue.prazoResposta);

        const dto = {
          id: this.data?.id || 0,
          osaExecucaoMatrizConstatacaoId: this.data.osaMatrizExecucaoId,
          prazoResposta: prazoDate ? prazoDate.toISOString() : null,
          nomeResponsavel: formValue.nomeResponsavel,
          cargoResponsavel: formValue.cargoResponsavel,
          descricaoEnvio: formValue.descricaoEnvio,
          descricaoManifestacao: formValue.descricaoManifestacao,
          nome: this.manifestacao?.nome || 'Manifestação do Auditado',
          responsavelPreenchimento: this.authService.usuario.id,
          status: this.manifestacao?.status || 1,
          dataFinalizacao: this.manifestacao?.dataFinalizacao || null,
          anexosEnviados: this.dataSourceEnviados.data,
          anexosRecebidos: this.dataSourceRecebidos.data
        };

        const res = await this.matrizService.salvarManifestacaoAuditado(dto);

        if (res?.sucesso) {
          this.manifestacao = res.dados;
          this.form.markAsPristine();
          this.submitted = false;
          this.executarEnvio();
        } else {
          this.exibirErro('Não foi possível salvar antes de enviar');
        }
      } catch {
        this.exibirErro('Não foi possível salvar antes de enviar');
      } finally {
        this.loading = false;
      }
    }


    public avaliar(): void {
      if (this.manifestacao?.status !== StatusManifestacao.Enviado) {
        this.exibirAviso('A manifestação ainda não foi enviada pelo auditado');
        return;
      }

      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        id: this.data.id,
        manifestacao: this.manifestacao,
        osaExecucaoId: this.data.osaMatrizExecucaoId,
        onEvaluated: () => {
          this.foiAvaliado = true;
          this.carregarManifestacao();
        }
      };

      const modal = this.matDialog.open(ModalAvaliarManifestacaoComponent, dialogConfig);
      modal.afterClosed().subscribe((resultado) => {
        if (resultado) {
          this.foiAvaliado = true;
          this.carregarManifestacao();
        }
      });
    }
    private executarEnvio(): void {
      this.loading = true;
      this.matrizService.enviarManifestacaoAuditado({
        manifestacaoId: this.data.id,
        usuarioId: this.authService.usuario.id
      })
        .then(res => {
          if (res.sucesso) {
            this.exibirSucesso('Manifestação enviada com sucesso')
            this.dialogRef.close(true);
          }
        })
        .finally(() => this.loading = false);
    }

    public fechar() {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = { interno: true };

      if (this.data.visualizar || this.foiAvaliado) {
        // Se foi só visualização ou houve avaliação, fecha passando true para o pai recarregar
        this.dialogRef.close(this.foiAvaliado ? true : undefined);
      } else {
        this.matDialog
          .open(ModalCancelarComponent, dialogConfig)
          .afterClosed()
          .subscribe((confirmou) => {
            if (confirmou) {
              this.dialogRef.close();
            }
          });
      }
    }

    public async adicionarArquivoEnviado(e: any) {
      const files = (e.target as HTMLInputElement).files;
      if (!files || files.length === 0) return;

      const flatListFiles = Array.from(files);

      for (let i = 0; i < flatListFiles.length; i++) {
        const file = flatListFiles[i];

        const tipo = file.type.toUpperCase();
        const sizeMB = Math.trunc(file.size / 1024 / 1024);

        // ✅ Validação de tipo (PDF, PNG, JPG, JPEG, XLSX e/ou MP4)
        if (tipo.includes("PDF") == false
          && tipo.includes("PNG") == false
          && tipo.includes("JPG") == false
          && tipo.includes("JPEG") == false
          && tipo.includes("MP4") == false
          && tipo.includes("EXCEL") == false
          && tipo.includes("VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET") == false) {
          this.exibirAviso("O formato do arquivo deve ser PDF, PNG, JPG, XLSX e/ou MP4");
          continue;
        }

        // ✅ Validação de tamanho específica para MP4
        if (tipo.includes("MP4")) {
          if (sizeMB > 28) {
            this.exibirAviso("Não é permitido vídeos com mais de 28MB");
            continue;
          }
        }
        else if (sizeMB > 28) {
          this.exibirAviso("Não é permitido arquivos com mais de 28MB");
          continue;
        }

        const base64 = await this.getBase64(file);

        const novo: IArquivoItemModel = {
          id: 0,
          nomeArquivo: file.name,
          arquivo: base64.toString()
        };

        this.dataSourceEnviados.data = [...this.dataSourceEnviados.data, novo];
      }

      this.dataSourceEnviados.paginator = this.paginatorEnviados;
      e.target.value = '';
    }



    public async adicionarArquivoRecebido(e: any) {
      const files = (e.target as HTMLInputElement).files;
      if (!files || files.length === 0) return;

      const flatListFiles = Array.from(files);

      for (let i = 0; i < flatListFiles.length; i++) {
        const file = flatListFiles[i];

        const tipo = file.type.toUpperCase();
        const sizeMB = Math.trunc(file.size / 1024 / 1024);

        // ✅ Validação de tipo (PDF, PNG, JPG, JPEG, XLSX e/ou MP4)
        if (tipo.includes("PDF") == false
          && tipo.includes("PNG") == false
          && tipo.includes("JPG") == false
          && tipo.includes("JPEG") == false
          && tipo.includes("MP4") == false
          && tipo.includes("EXCEL") == false
          && tipo.includes("VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET") == false) {
          this.exibirAviso("O formato do arquivo deve ser PDF, PNG, JPG, XLSX e/ou MP4");
          continue;
        }

        // ✅ Validação de tamanho específica para MP4
        if (tipo.includes("MP4")) {
          if (sizeMB > 28) {
            this.exibirAviso("Não é permitido vídeos com mais de 28MB");
            continue;
          }
        }
        else if (sizeMB > 28) {
          this.exibirAviso("Não é permitido arquivos com mais de 28MB");
          continue;
        }

        const base64 = await this.getBase64(file);

        const novo: IArquivoItemModel = {
          id: 0,
          nomeArquivo: file.name,
          arquivo: base64.toString()
        };

        this.dataSourceRecebidos.data = [...this.dataSourceRecebidos.data, novo];
      }

      this.dataSourceRecebidos.paginator = this.paginatorRecebidos;
      e.target.value = '';
    }



    public removerAnexoEviado(index: number, item: any): void {
      Swal.fire({
        title: "Excluir Registro",
        text: "Tem certeza que deseja excluir esse Registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((res) => {
        if (!res.value) return;

        const id = Number(item?.id || item?.Id || 0);

        // 1) Se ainda não salvou no banco (sem id): remove só da lista
        if (!id || id === 0) {
          const data = [...this.dataSourceEnviados.data];
          data.splice(index, 1);
          this.dataSourceEnviados.data = data;
          this.dataSourceEnviados.paginator = this.paginatorRecebidos;
          return;
        }

        // 2) Se tem id: chama backend e depois atualiza tela/lista
        this.matrizService
          .excluirAnexoEviado(this.data?.id, id) // ajuste aqui para os parâmetros do seu endpoint
          .then((r) => {
            if (r?.sucesso) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                text: r.mensagem?.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: r.mensagem?.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              text: err?.mensagem?.descricao ?? "Erro ao excluir o anexo.",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          })
          .finally(() => {
            this.carregarManifestacao()
          });
      });
    }

    public download(arquivo: IArquivoItemModel) {
      this.matrizService.downloadAnexoEnviadoManifestacaoAuditado(this.data.id, arquivo.id).then((res) => {
        if (res.sucesso) {
          const link = document.createElement("a");
          link.href = res.dados.toString();
          link.download = arquivo.nomeArquivo;
          link.click();
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
    }

    public downloadRecebido(arquivo: IArquivoItemModel) {
      this.matrizService.downloadAnexoRecebidoManifestacaoAuditado(this.data.id, arquivo.id).then((res) => {
        if (res.sucesso) {
          const link = document.createElement("a");
          link.href = res.dados.toString();
          link.download = arquivo.nomeArquivo;
          link.click();
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      })
    }

    public removerAnexoRecebido(index: number, item: any): void {
      Swal.fire({
        title: "Excluir Registro",
        text: "Tem certeza que deseja excluir esse Registro?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((res) => {
        if (!res.value) return;

        const id = Number(item?.id || item?.Id || 0);

        // 1) Se ainda não salvou no banco (sem id): remove só da lista
        if (!id || id === 0) {
          const data = [...this.dataSourceRecebidos.data];
          data.splice(index, 1);
          this.dataSourceRecebidos.data = data;
          this.dataSourceRecebidos.paginator = this.paginatorRecebidos;
          return;
        }

        // 2) Se tem id: chama backend e depois atualiza tela/lista
        this.matrizService
          .excluirAnexoRecebido(this.data?.id, id) // ajuste aqui para os parâmetros do seu endpoint
          .then((r) => {
            if (r?.sucesso) {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                text: r.mensagem?.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: r.mensagem?.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "error",
              text: err?.mensagem?.descricao ?? "Erro ao excluir o anexo.",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          })
          .finally(() => {
             // padrão do seu exemplo
          });
      });
    }



    public getBase64(file: File) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }

    private exibirSucesso(mensagem: string): void {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        text: mensagem,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true
      });
    }
    private exibirAviso(mensagem: string): void {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: mensagem,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true
      });
    }

    private exibirErro(mensagem: string): void {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: mensagem,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true
      });
    }

    public readonly StatusManifestacao = StatusManifestacao;
  }
